module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAuElEQVQ4jd3SPQrCMBjG8ecIHqH4JtIb5Ck45CiOTuIguDh0FQ/gERw9gIdySJNMUgcphIr0AwXpC//lHX4kJEBrPOXhqeoxBYpve4hmsayoV0MKhdo26Bs4dirK0VPVGHu9tBc4308AjJQzAFSF3n0FdFQlADgqO1lQHxyVbYrMMwC422yW7j31uhc45CP3PKHcHFWZZAEgMs/SfTBymcyj/Bj0Rl0BIBg5dYGBsukGe/bx+f8SfALx6tRwff6f9wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/images/copy.png
// module id = I+r1
// module chunks = 2